var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height pa-0",attrs:{"max":"","fluid":""}},[_c('v-row',{staticClass:"py-0 my-0 px-0 mx-0",staticStyle:{"height":"100%"}},[_c('v-col',{staticClass:"pa-0",staticStyle:{"height":"100%"}},[_c('stats-analytics'),_c('dashboard-navigation')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }